export enum ReportTemplateIdEnum {
  AREAS_REPORT = "AREAS_REPORT",
  OCCUPANCY_REPORT = "OCCUPANCY_REPORT",
  WORKER_COST_REPORT = "WORKER_COST_REPORT",
  RIDE_ANALYTICS_REPORT = "RIDE_ANALYTICS_REPORT",
  DETAILED_PASSENGERS_COST_REPORT = "DETAILED_PASSENGERS_COST_REPORT",
  DETAILED_RIDES_REPORT = "DETAILED_RIDES_REPORT",
  MANUAL_REMOVED_PASSENGERS_REPORT = "MANUAL_REMOVED_PASSENGERS_REPORT",
  UNITS_COSTS_REPORT = "UNITS_COSTS_REPORT",
  MEALS_REPORT = "MEALS_REPORT",
  PLAN_VS_EXECUTION_REPORT = "PLAN_VS_EXECUTION_REPORT",
  ALL_PASSENGERS_BOOKINGS_REPORT = "ALL_PASSENGERS_BOOKINGS_REPORT",
  AREAS_GROUPS_REPORT = "AREAS_GROUPS_REPORT",
  WAITING_LIST_REPORT = "WAITING_LIST_REPORT",
  // Supplier-specific report templates
  SUPPLIER_RIDE_ANALYTICS_REPORT = "SUPPLIER_RIDE_ANALYTICS_REPORT",
  SUPPLIER_DETAILED_PASSENGERS_COST_REPORT = "SUPPLIER_DETAILED_PASSENGERS_COST_REPORT",
  SUPPLIER_DETAILED_RIDES_REPORT = "SUPPLIER_DETAILED_RIDES_REPORT",
  SUPPLIER_WORKER_COST_REPORT = "SUPPLIER_WORKER_COST_REPORT",
  SUPPLIER_AREAS_REPORT = "SUPPLIER_AREAS_REPORT",
  SUPPLIER_AREAS_GROUPS_REPORT = "SUPPLIER_AREAS_GROUPS_REPORT",
  SUPPLIER_OCCUPANCY_REPORT = "SUPPLIER_OCCUPANCY_REPORT",
  SUPPLIER_UNITS_COSTS_REPORT = "SUPPLIER_UNITS_COSTS_REPORT",
}

export const ALLOW_BULK_ACTIONS_REPORTS_IDS_SET = new Set<ReportTemplateIdEnum>(
  [ReportTemplateIdEnum.RIDE_ANALYTICS_REPORT],
);

export const REPORT_INNER_IDS_KEY = "innerItemsIds";
